import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import Spinner from '../../components/Common/Spinner/Spinner';
import routes from '../../constants/routes';

import { decodeUrlAction } from '../../actions/proceedingActions';
import { Alert, Col } from 'react-bootstrap';

const OpenProceeding = () => {
    //Tomo el history
    const history = useHistory();
    const dispatch = useDispatch();
    //Debo tomar el código
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    //Tomo el parámetro
    const code = query.get('c');
    //Tomo el store
    const loading = useSelector(state => state.proceeding.loading);
    const error = useSelector(state => state.proceeding.error);
    //Al inicio ejecuto operación
    useEffect(() => {
        //Ejecuto
        handleDecode();
    }, []);
    //Manejo el inicio
    const handleDecode = () => {
        //Verifico que el código esté ok
        if(typeof code === "undefined" || !code || code.trim() === ''){
            //Redirecciono a home
            history.push(routes.HOME);
        }
        //Ejecuto
        dispatch( decodeUrlAction(code, history) );
    }
    //Render
    return (
        <Spinner active={loading}>
            <div className="w-100 vertical-centered">
                <div className="d-flex justify-content-center">
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center mb-4">
                            <div className="icon-module icon-module-orange">
                                <FontAwesomeIcon icon={faSearch} className="h1 mt-2" />
                            </div>
                        </div>
                        <div className="col-12 d-flex justify-content-center">
                            <h2>{ process.env.REACT_APP_NAME }</h2>
                        </div>
                        <div className="col-12 d-flex justify-content-center">
                            <h6 className="text-muted">Estamos buscando los datos del Expediente, por favor aguarde...</h6>
                        </div>
                        {
                            error && error.message ? (
                                <Col xs={12} className="d-flex justify-content-center mt-5">
                                    <Alert variant="danger">
                                        { error.message }
                                    </Alert>
                                </Col>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </Spinner>
    );
};

export default OpenProceeding;